import React from 'react';
import { Checkbox, CheckBoxParam, Fieldset, Row } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export function ChangeListFormTemplate({
  params,
}: {
  params: ReadonlyArray<CheckBoxParam<'checkListItem'>> | undefined;
}) {
  const { t } = useSonTranslation('TicketBooking');

  return (
    <Fieldset legend={t('default.bookTicketCheckListFieldSet')}>
      {params?.map(param => (
        <Row key={param.displayName}>
          <Checkbox label={param.displayName} param={param} />
        </Row>
      ))}
    </Fieldset>
  );
}
